import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Attachment } from '../../models/attachment.model';
import { AttachmentService } from '../../services/attachment.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { from } from 'rxjs';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrl: './attachment-list.component.scss'
})
export class AttachmentListComponent implements OnInit, AfterViewInit {

  @Input() canDelete? = true;
  @Input() attachments: Array<Attachment> = [];
  @Output() onAttachmentRemoved: EventEmitter<Attachment> = new EventEmitter<Attachment>();
  attachmentList: Array<Attachment> = [];

  constructor(private attachmentService: AttachmentService, public dialog: MatDialog) { }

  ngAfterViewInit(): void {
  }
  
  async ngOnChanges() {
    this.attachmentList = structuredClone(this.attachments);
  }

  async ngOnInit() {
    this.attachmentList = structuredClone(this.attachments);
  }

  async open(attachment: Attachment) {
    this.attachmentService.getAttachmentReadUrl(attachment.FileName,
      attachment.expiry, attachment.readUrl)?.subscribe({
        next: (result) => {
          const idx = this.attachmentList.findIndex(a => a.FileName === attachment.FileName);
          if (idx !== -1) {
            this.attachmentList[idx].readUrl = result.readSasUri;
            this.attachmentList[idx].expiry = result.expiresOn;
          } else {
            console.warn(`Attachment with FileName ${attachment.FileName} not found in the list.`);
          }
          console.log(result);
          window.open(result.readSasUri, '_blank');
        },
        error: (err) => {
          console.error('Error fetching attachment read URL:', err);
        }
      });
  }

  remove(data: Attachment) {
    console.log('Removing attachment:', data);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      autoFocus: false,
      data: {
        title: 'Confirm Deletion',
        message: 'Are you sure you want to delete this attachment?',
        cancelText: 'Cancel',
        confirmText: 'Yes, Delete',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog result:', result);
      if (result === true) {
        // User confirmed removal
        this.attachmentService.removeUploadedFile(data.FileName).subscribe({
        // from(this.attachmentService.removeUploadingFile(url)).subscribe({
          next: () => {
            this.attachmentList = this.attachmentList.filter(a => a.Id !== data.Id);
            console.log('Attachment removed successfully');
            this.onAttachmentRemoved.emit(data);
          },
          error: (err) => {
            console.error('Error removing attachment:', err);
          }
        });
      }
    });
  }

  shortFileNameWithExt(fileName: string): string {
    return this.attachmentService.shortFileNameWithExt(fileName);
  }
}

/**
 * TODO:
 * 1. Implement the remove method to handle attachment removal
 *    - This should call the AttachmentService to delete the attachment from Azure Blob Storage
 *    - Emit an event to notify the parent component about the removal so it can update the attachments list 
 *       e.g., onAttachmentRemoved.emit(data);
 * 2. An attachment removal should 
 *   - Delete the blob db record in addition to removing the file from the server/Azure Blob Storage
 *   - Update the parent component with the attachments list
 * 3. Add a confirmation dialog before removing an attachment
 * 4. Disable file selection while upload to Azure Blob Storage is in progress?
 */

